<template>
  <v-btn
    color="deep-orange white--text"
    depressed
    class="my-2"
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
    ><slot
  /></v-btn>
</template>

<script>
export default {
  name: 'BtnBaseOrange',
  components: {},
  props: {},
  data() {
    return {}
  },
}
</script>
